import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { useToast } from '@chakra-ui/react';
import { Alert } from './Alert.js';

function useAlert() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'success';
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'toast';
  var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'top-right';
  /**
   * Hooks
   */

  var toast = useToast({
    // Defaults
    position: position
  });

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  return React.useCallback(function (_ref) {
    var id = _ref.id,
        title = _ref.title,
        description = _ref.description,
        _ref$isClosable = _ref.isClosable,
        isClosable = _ref$isClosable === void 0 ? true : _ref$isClosable,
        _ref$showIcon = _ref.showIcon,
        showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon,
        actions = _ref.actions,
        _ref$onClose = _ref.onClose,
        onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;
    /**
     * Methods
     */

    var handleOnClose = function handleOnClose(e) {
      setIsVisible(false);
      onClose(e);
    }; // context is inline


    if (context === 'inline') {
      if (isVisible) {
        return /*#__PURE__*/React.createElement(Alert, {
          variant: variant,
          title: title,
          description: description,
          isClosable: isClosable,
          showIcon: showIcon,
          actions: actions,
          onClose: handleOnClose
        });
      }

      return null;
    } // otherwise toast


    if (toast.isActive(id)) {
      return null;
    }

    toast({
      id: id,
      isClosable: isClosable,
      render: function render() {
        return /*#__PURE__*/React.createElement(Alert, {
          variant: variant,
          title: title,
          description: description,
          isClosable: isClosable,
          showIcon: showIcon,
          actions: actions,
          onClose: function onClose() {
            return toast.close(id);
          }
        });
      }
    });
    return null;
  }, [variant, context, toast, isVisible]);
}

export { useAlert };